import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api-client";
import { formatBRL, formatDateTimeSaoPaulo } from "../../lib/currency";
import { usePagination } from "../../hooks/usePagination";
import { Pagination } from "../../components/Pagination";

interface AdminOrder {
  id: string;
  order_number: string;
  status: string;
  total_cents: number;
  invoice_status: string;
  created_at: string;
}

function statusBadgeClass(status: string): string {
  if (status === "paid") return "status-badge--paid";
  if (status === "pending") return "status-badge--pending";
  if (["expired", "cancelled", "blocked", "disputed"].includes(status)) return "status-badge--negative";
  return "";
}

export function AdminOrdersPage() {
  const [orders, setOrders] = useState<AdminOrder[]>([]);
  const pagination = usePagination(orders, 15);

  useEffect(() => {
    apiClient.get<{ items: AdminOrder[] }>("/admin/orders").then((data) => setOrders(data.items));
  }, []);

  return (
    <div>
      <h2>Pedidos / Pix</h2>
      <div className="card" style={{ overflowX: "auto" }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Pedido</th>
              <th>Status</th>
              <th className="num">Total</th>
              <th>Nota fiscal</th>
              <th>Criado em</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            {pagination.paginatedItems.map((order) => (
              <tr key={order.id}>
                <td>{order.order_number}</td>
                <td>
                  <span className={`status-badge ${statusBadgeClass(order.status)}`}>{order.status}</span>
                </td>
                <td className="num">{formatBRL(order.total_cents)}</td>
                <td>{order.invoice_status}</td>
                <td>{formatDateTimeSaoPaulo(order.created_at)}</td>
                <td>
                  {order.status === "paid" && (
                    <button className="btn btn-secondary" onClick={() => apiClient.post(`/admin/orders/${order.id}/refund`)}>
                      Reembolsar
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={pagination.currentPage}
          totalItems={pagination.totalItems}
          pageSize={pagination.pageSize}
          onPageChange={pagination.setCurrentPage}
          itemLabel="pedidos"
        />
      </div>
    </div>
  );
}
